export const environment = {
  production: true,
  name: 'prod',
  mockApi: false,
};
